var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWalliserguide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.545,
    height: 83.526,
    viewBox: "0 0 68.545 83.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4",
    "data-name": "Gruppe 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5",
    "data-name": "Gruppe 5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8",
    "data-name": "Pfad 8",
    d: "M1.621,62.751.027,93.242h0c-.743,17.871,13.79,32.988,32.465,33.765h0c18.671.777,34.412-13.081,35.156-30.952l.9-16.754S57.78,72.138,45.968,71.622c-9.614-.42-19.921,6.01-25.683,4.436A32.932,32.932,0,0,1,1.621,62.751",
    transform: "translate(0 -43.512)",
    fill: "#cf312e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_9",
    "data-name": "Pfad 9",
    d: "M1.314,62.751.027,93.242h0c-.743,17.871,13.79,32.988,32.465,33.765h0c18.671.777,34.412-13.081,35.156-30.952l.9-16.754s-14.887,1.89-21.393,1.769c-11.512-.214-20.372-7.109-28.576-9.351C5.736,68.21,1.314,62.751,1.314,62.751",
    transform: "translate(0 -43.512)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10",
    "data-name": "Pfad 10",
    d: "M158.5,31.778l2.016,6.274,6.049.252-4.914,3.076,1.574,5.94-5.219-3.679-5.462,3.234,2.06-5.833-4.681-3.431,6.045.251Z",
    transform: "translate(-103.961 -22.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11",
    "data-name": "Pfad 11",
    d: "M156.464,80.8l2.016,6.28,6.049.252-4.913,3.071,1.573,5.94-5.218-3.677L150.508,95.9l2.06-5.834-4.681-3.426,6.045.251Z",
    transform: "translate(-102.546 -56.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12",
    "data-name": "Pfad 12",
    d: "M154.424,129.834l2.016,6.278,6.049.252-4.914,3.076,1.573,5.94-5.218-3.677-5.463,3.233,2.061-5.834-4.681-3.431,6.045.251Z",
    transform: "translate(-101.131 -90.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13",
    "data-name": "Pfad 13",
    d: "M152.384,178.876l2.016,6.276,6.049.252-4.914,3.075,1.574,5.938-5.219-3.677-5.462,3.233,2.061-5.834-4.681-3.427,6.045.251Z",
    transform: "translate(-99.717 -124.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14",
    "data-name": "Pfad 14",
    d: "M115.618,12.93l2.016,6.279,6.049.251-4.953,3.026,1.619,5.988-5.223-3.68Z",
    transform: "translate(-79.828 -8.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    d: "M113.578,61.961l2.016,6.277,6.049.252-4.953,3.026,1.619,5.986-5.224-3.677Z",
    transform: "translate(-78.413 -42.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    d: "M111.538,111l2.016,6.277,6.049.252-4.953,3.027,1.619,5.984-5.224-3.678Z",
    transform: "translate(-76.999 -76.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    "data-name": "Pfad 17",
    d: "M109.5,160.018l2.016,6.279,6.049.251-4.954,3.03,1.619,5.985L109,171.887Z",
    transform: "translate(-75.584 -110.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18",
    "data-name": "Pfad 18",
    d: "M107.459,209.062l2.016,6.276,6.049.252-4.953,3.026,1.619,5.988-5.224-3.679Z",
    transform: "translate(-74.17 -144.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_19",
    "data-name": "Pfad 19",
    d: "M30.608,43.3l-4.64-3.474,6.048.252,2.519-6.03.131-3.179-5.5,3.184,2.067-5.789-4.641-3.471,6.048.251,2.514-6.019.132-3.187-5.495,3.182,2.066-5.789-4.64-3.472,6.048.252L35.776,4l.107-2.593L2.1,0,.027,49.731C-.716,67.6,13.817,82.719,32.493,83.5l1.553-37.6-5.5,3.186ZM19.5,68.807l-5.22-3.677L8.815,68.363l2.064-5.833L6.194,59.1l6.046.251,2.532-6.087,2.016,6.276,6.045.251-4.909,3.075Zm-.949-20.97,1.574,5.94L14.9,50.1,9.441,53.332,11.5,47.5,6.819,44.068l6.046.251L15.4,38.231l2.016,6.278,6.045.252ZM19.174,32.8l1.574,5.94-5.22-3.678L10.066,38.3l2.064-5.833L7.445,29.038l6.046.252L16.022,23.2l2.015,6.28,6.045.251ZM19.8,17.769l1.574,5.94-5.22-3.679-5.463,3.235,2.064-5.833L8.07,14l6.046.251,2.532-6.084,2.016,6.274,6.045.252Zm13,58.192-5.5,3.189,2.067-5.791-4.64-3.473,6.048.252,2.524-6.04ZM31.39,55.107l2.524-6.045-.494,11.869-5.5,3.187,2.066-5.789-4.64-3.474Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalliserguide);
export default __webpack_public_path__ + "static/media/icon-walliserguide.371fb4231615e4b5c13c79b18102cf6c.svg";
export { ForwardRef as ReactComponent };